export const getFormerDay = (daysBack: number) => {
  const now = new Date()
  now.setHours(0, 0, 0, 0)

  const daysAgo = new Date()
  daysAgo.setDate(now.getDate() - daysBack)

  return daysAgo
}
